var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-container",
    { attrs: { "no-padding": "" } },
    [
      _c(
        "w-row",
        { style: { maxHeight: "100%" }, attrs: { grow: "", "no-margin": "" } },
        [
          _c(
            "w-col",
            {
              staticClass: "mts",
              attrs: { xs: "12", sm: "3", md: "4", xl: "3" },
            },
            [
              _c("threads", { attrs: { state: _vm.state } }),
              _c(
                "channel-list",
                { attrs: { state: _vm.state } },
                [
                  _c("template", { slot: "title" }, [
                    _vm._v(" " + _vm._s(_vm.$ct("channels")) + " "),
                  ]),
                ],
                2
              ),
              _c(
                "user-list",
                { attrs: { state: _vm.state } },
                [
                  _c("template", { slot: "title" }, [
                    _vm._v(" " + _vm._s(_vm.$ct("user-list-title")) + " "),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "w-col",
            {
              attrs: {
                xs: "12",
                sm: "9",
                md: "8",
                xl: "9",
                "no-padding": "",
                "no-margin": "",
              },
            },
            [
              _vm.$route.params.threadId
                ? _c("thread-info", { attrs: { state: _vm.state } })
                : _vm._e(),
              !_vm.$route.params.threadId
                ? _c("router-view", {
                    key: _vm.$route.params.folderId,
                    attrs: { state: _vm.state },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }